var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayeredPeaksHaikei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 960 540",
    width: 960,
    height: 540,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 960,
    height: 540,
    fill: "#038373"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 352L137 395L274 348L411 336L549 398L686 331L823 319L960 346L960 541L823 541L686 541L549 541L411 541L274 541L137 541L0 541Z",
    fill: "#aed581"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 426L137 366L274 379L411 362L549 383L686 388L823 410L960 423L960 541L823 541L686 541L549 541L411 541L274 541L137 541L0 541Z",
    fill: "#85c17e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 435L137 442L274 419L411 409L549 436L686 434L823 435L960 405L960 541L823 541L686 541L549 541L411 541L274 541L137 541L0 541Z",
    fill: "#5ead7b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 453L137 456L274 470L411 439L549 458L686 444L823 444L960 487L960 541L823 541L686 541L549 541L411 541L274 541L137 541L0 541Z",
    fill: "#389878"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 497L137 508L274 498L411 491L549 508L686 476L823 493L960 513L960 541L823 541L686 541L549 541L411 541L274 541L137 541L0 541Z",
    fill: "#038373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayeredPeaksHaikei);
export default __webpack_public_path__ + "static/media/layered-peaks-haikei.d5b46ac19e760c3861c54704b8566a23.svg";
export { ForwardRef as ReactComponent };